
export const TIPO_DIA_CALENDARIO = {

    FERIADO_NACIONAL: 730,
    ASUETO: 731,
    OTROS: 732,
    RETENCIONES: 733,
    FERIADO_MUNICIPAL: 734,
    VENCIMIENTOS_DDJJ: 735,
    HABILITACION_DDJJ: 736

}
